import { useGetMembershipDetail } from '#api/member';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import dayjs from 'dayjs';
import { useParams } from 'react-router';

const DashboardMembership = () => {
  const { personId, confirmationFormId } = useParams();

  const { data: membership } = useGetMembershipDetail(
    personId || '',
    confirmationFormId || ''
  );

  if (!membership) return null;

  const membershipData = [
    { label: '수업', value: membership.title },
    { label: '수업 시간', value: `${membership.sessionDuration}분` },
    {
      label: '개시 날짜',
      value: dayjs(membership.startedDate).format('MM월 DD일 (ddd)')
    },
    {
      label: '유효기간',
      value: membership.expiryDate
        ? `${dayjs(membership.expiryDate).diff(
            membership.startedDate,
            'day'
          )}일`
        : '무기한'
    },
    {
      label: '만료 날짜',
      value: membership.expiryDate
        ? dayjs(membership.expiryDate).format('MM월 DD일 (ddd)')
        : '무기한'
    },
    { label: '총 회차', value: `${membership.totalRound} 회차` },
    { label: '현재 회차', value: `${membership.completedRoundUntilNow} 회차` },
    { label: '할인', value: '없음' }, // API에 할인 정보가 없으므로 고정값
    { label: '결제 상태', value: membership.isPaid ? '결제 완료' : '결제 예정' }
  ];

  return (
    <PrevHeaderBarWithTitleTemplate defaultBackground title={'수강권'}>
      <div className="py-28 px-20">
        <div>
          {membershipData.map((item, index) => (
            <Item key={index} title={item.label} value={item.value} />
          ))}
        </div>
        <TotalPrice price={0} />
      </div>
    </PrevHeaderBarWithTitleTemplate>
  );
};

interface TotalPriceProps {
  price: number;
}
const TotalPrice = ({ price }: TotalPriceProps) => {
  return (
    <div className="w-full flex flex-col justify-center h-[89px] p-4 bg-[#1e1a24] rounded-lg border-1 border-solid border-[#252230]  items-center gap-8 ">
      <div className="text-[#938f9e] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
        총 결제 금액
      </div>
      <div className="justify-center items-center gap-1 inline-flex">
        <div className="text-[#7750e9] text-[22px] font-bold font-['Pretendard Variable'] leading-7 tracking-tight">
          {price.toLocaleString()}
        </div>
        <div className="text-[#938f9e] text-base font-medium font-['Pretendard Variable'] leading-[21px]">
          원
        </div>
      </div>
    </div>
  );
};

interface ItemProps {
  title: string;
  value: string;
}
const Item = ({ title, value }: ItemProps) => {
  return (
    <div className="h-[45px] py-1 justify-between items-center inline-flex">
      <div className="text-[#938f9e] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
        {title}
      </div>
      <div className="text-[#bcb8c3] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
        {value}
      </div>
    </div>
  );
};

export default DashboardMembership;
